module.exports = __webpack_public_path__ + "img/3-left.d3c3f2b9.png";